import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  Radio,
  Typography,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import { UseDiscountCode } from "./UseDiscountCode";
import Detail from "../../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { toMoney, removeComma } from "../../../util/Utils";
import CodeUser from "./CodeUser";
import CodeProduct from "./CodeProduct";
import CodeBrand from "./CodeBrand";
import CodeGroup from "./CodeGroup";
import CodeCategory from "./CodeCategory";
import CodeSMS from "./CodeSMS";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditDiscountCode() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [showProducts, setShowProducts] = useState(false);
  const [showBrands, setShowBrands] = useState(false);
  const [showGroups, setShowGroups] = useState(false);
  const [showCategoris, setShowCategoris] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [showSMS, setShowSMS] = useState(false);
  const [expireDate, setExpireDate] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const {
    getDiscountCodeById,
    validate,
    editDiscountCode,
    RandomDiscountCode,
  } = UseDiscountCode();
  const [Code, setCode] = useState("");
  const [state, setState] = useState({
    id: undefined,
    discountCode: undefined,
    expireDate: undefined,
    discountCost: undefined,
    minOrderLimit: undefined,
    discountPercent: undefined,
    smsid: 5,
    isActive: false,
    allOrder: false,
    isPublic: false,
    freeDelivery: false,
    onlyFirstOrder: false,
    oneUse: false,
    allOneUse: false,
  });
  const [value, setValue] = useState("");
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (Code) {
      setState({ ...state, discountCode: Code });
    }
  }, [Code]);

  useEffect(() => {
    let newValueStart = expireDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, expireDate: newValueStart });
  }, [expireDate]);

  const [errorState, setErrorState] = useState({
    discountCode: false,
  });
  const { toSolar } = require("jdate-convert");

  useEffect(() => {
    if (location.state && location.state.id) {
      getDiscountCodeById(location.state.id, (callback) => {
        setState({
          id: callback.id,
          discountCode: callback.discountCode,
          expireDate: callback.expireDate
            ? callback.expireDate.split("T")[0]
            : "",
          discountCost: callback.discountCost,
          minOrderLimit: callback.minOrderLimit,
          //   smsid: callback.smsid,
          discountPercent: callback.discountPercent,
          freeDelivery: callback.freeDelivery,
          onlyFirstOrder: callback.onlyFirstOrder,
          oneUse: callback.oneUse,
          isActive: callback.isActive,
          allOrder: callback.allOrder,
          isPublic: callback.isPublic,
          allOneUse: callback.allOneUse,
        });
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: "کد تخفیف",
            url: "/discountmanagment/discountCode",
          },
          {
            name: "ویرایش کد تخفیف",
            url: "/discountmanagment/discountCode/editCode",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 11" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountCode ? state.discountCode : ""}
            label="کد تخفیف"
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
            // onChange={(event) => {
            //   setState({
            //     ...state,
            //     discountCode: event.target.value,
            //   });
            // }}
          />
        </Box>
        <Box sx={{ my: "auto" }} gridColumn="span 1">
          <Button
            onClick={() => {
              RandomDiscountCode((callBack) => {
                setCode(callBack);
              });
            }}
            sx={{ width: "100px" }}
            variant="contained"
          >
            ایجاد کد
          </Button>
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <DatePicker
            // highlightToday={false}
            onOpenPickNewDate={false}
            weekDays={weekDays}
            calendar={persian}
            locale={persian_fa}
            format="YYYY-MM-DD"
            value={state && state.expireDate ? toSolar(state.expireDate) : ""}
            onChange={setExpireDate}
            containerStyle={{
              width: "100%",
            }}
            render={
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                size="small"
                fullWidth
                label="تاریخ انقضا"
              />
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountCost ? toMoney(state.discountCost) : ""}
            label="مبلغ تخفیف (تومان)"
            variant="outlined"
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            onChange={(event) => {
              setState({
                ...state,
                discountCost: removeComma(event.target.value),
              });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            size="small"
            fullWidth
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            id="outlined-basic"
            // type="number"
            // InputProps={{
            //   autoComplete: "off",
            //   inputProps: {
            //     min: 1,
            //   },
            // }}
            value={state.minOrderLimit ? toMoney(state.minOrderLimit) : ""}
            label="حداقل مبلغ سفارش (تومان)"
            variant="outlined"
            onChange={(event) => {
              setState({
                ...state,
                minOrderLimit: removeComma(event.target.value),
              });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <TextField
            size="small"
            fullWidth
            id="outlined-basic"
            value={state.discountPercent ? toMoney(state.discountPercent) : ""}
            label="درصد تخفیف"
            variant="outlined"
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            onChange={(event) => {
              setState({
                ...state,
                discountPercent: event.target.value
                  ? removeComma(event.target.value)
                  : 0,
              });
            }}
          />
        </Box>
        <Box gridColumn="span 10"></Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <FormControlLabel
            checked={state.freeDelivery}
            onChange={(evt) => {
              setState({ ...state, freeDelivery: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="ارسال رایگان"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 5"}>
          <FormControlLabel
            checked={state.onlyFirstOrder}
            onChange={(evt) => {
              setState({ ...state, onlyFirstOrder: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="فقط برای سفارش اول"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box sx={{ display: "flex" }} gridColumn="span 12">
          <FormControlLabel
            checked={state.oneUse}
            onChange={(evt) => {
              setState({ ...state, oneUse: evt.target.checked });
              if (evt.target.checked == false) {
                setState({
                  ...state,
                  oneUse: evt.target.checked,
                  allOneUse: false,
                });
              }
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="یکبار مصرف :"
          />
          <FormControl disabled={state.oneUse ? false : true}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={state.allOneUse}
              onChange={(event) => {
                setState({ ...state, allOneUse: event.target.value });
              }}
            >
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="به ازای هر نفر"
              />
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="یکبار استفاده"
              />
            </RadioGroup>
          </FormControl>
        </Box>
        {/* <Box gridColumn={isSmall ? "span 12" : "span 7"}></Box> */}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <FormControlLabel
            checked={state.isActive}
            onChange={(evt) => {
              setState({ ...state, isActive: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="فعال"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn="span 12">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #c1c1c1",
              p: 1,
              borderRadius: 3,
              width: "fit-content",
            }}
          >
            {state.isPublic ? (
              <Typography sx={{ mr: 2 }}>تمامی کاربران</Typography>
            ) : (
              <Typography sx={{ mr: 2 }}>کاربران منتخب</Typography>
            )}
            <Button
              onClick={() => setShowUser(true)}
              variant="contained"
              size="small"
              sx={{
                width: "100px",
                bgcolor: "#2700ff",
                ":hover": { bgcolor: "#2700ff" },
              }}
            >
              فیلتر کاربر
            </Button>
          </Box>
        </Box>
        <Box gridColumn="span 12">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #c1c1c1",
              p: 1,
              borderRadius: 3,
              width: "fit-content",
              gap: 1,
              flexDirection: isSmall ? "column" : "row",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {state.allOrder ? (
                <Typography sx={{ mr: 2 }}>تمامی سفارشات</Typography>
              ) : (
                <Typography sx={{ mr: 2 }}>سفارشات منتخب</Typography>
              )}
              <Button
                onClick={() => setShowProducts(true)}
                variant="contained"
                color="warning"
                sx={{
                  width: "100px",
                  bgcolor: "#cd0000",
                  ":hover": { bgcolor: "#cd0000" },
                }}
              >
                فیلتر محصول
              </Button>
              <Button
                onClick={() => setShowBrands(true)}
                variant="contained"
                sx={{
                  width: "100px",
                  bgcolor: "#ff0000",
                  ":hover": { bgcolor: "#ff0000" },
                }}
              >
                فیلتر برند
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                onClick={() => setShowGroups(true)}
                variant="contained"
                sx={{
                  width: "100px",
                  bgcolor: "#ff3434",
                  ":hover": { bgcolor: "#ff3434" },
                }}
              >
                فیلتر گروه
              </Button>
              <Button
                onClick={() => setShowCategoris(true)}
                variant="contained"
                sx={{
                  width: "100px",
                  bgcolor: "#ff000096",
                  ":hover": { bgcolor: "#ff000096" },
                }}
              >
                فیلتر دسته
              </Button>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mt: 3,
          }}
          gridColumn={isSmall ? "span 12" : "span 4"}
        >
          <Button
            variant="contained"
            sx={{ mr: 2, width: "100px" }}
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                editDiscountCode(state, (callback) => {
                  navigate("/discountmanagment/discountCode", {
                    state: location.state,
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            color="secondary"
            variant="outlined"
            onClick={() => {
              navigate("/discountmanagment/discountCode", {
                state: location.state,
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
      {showUser && (
        <CodeUser
          setShowUser={setShowUser}
          showUser={showUser}
          DiscountID={state.id}
          callback={(id) => {
            getDiscountCodeById(id, (callback) => {
              setState({
                id: callback.id,
                discountCode: callback.discountCode,
                expireDate: callback.expireDate
                  ? callback.expireDate.split("T")[0]
                  : "",
                discountCost: callback.discountCost,
                minOrderLimit: callback.minOrderLimit,
                //   smsid: callback.smsid,
                freeDelivery: callback.freeDelivery,
                onlyFirstOrder: callback.onlyFirstOrder,
                oneUse: callback.oneUse,
                isActive: callback.isActive,
                allOrder: callback.allOrder,
                isPublic: callback.isPublic,
              });
            });
          }}
        />
      )}
      {showProducts && (
        <CodeProduct
          setShowProducts={setShowProducts}
          showProducts={showProducts}
          DiscountID={state.id}
          callback={(id) => {
            getDiscountCodeById(id, (callback) => {
              setState({
                id: callback.id,
                discountCode: callback.discountCode,
                expireDate: callback.expireDate
                  ? callback.expireDate.split("T")[0]
                  : "",
                discountCost: callback.discountCost,
                minOrderLimit: callback.minOrderLimit,
                //   smsid: callback.smsid,
                discountPercent: callback.discountPercent,
                freeDelivery: callback.freeDelivery,
                onlyFirstOrder: callback.onlyFirstOrder,
                oneUse: callback.oneUse,
                isActive: callback.isActive,
                allOrder: callback.allOrder,
                isPublic: callback.isPublic,
              });
            });
          }}
        />
      )}
      {showBrands && (
        <CodeBrand
          setShowBrands={setShowBrands}
          showBrands={showBrands}
          DiscountID={state.id}
          callback={(id) => {
            getDiscountCodeById(id, (callback) => {
              setState({
                id: callback.id,
                discountCode: callback.discountCode,
                expireDate: callback.expireDate
                  ? callback.expireDate.split("T")[0]
                  : "",
                discountCost: callback.discountCost,
                minOrderLimit: callback.minOrderLimit,
                discountPercent: callback.discountPercent,
                //   smsid: callback.smsid,
                freeDelivery: callback.freeDelivery,
                onlyFirstOrder: callback.onlyFirstOrder,
                oneUse: callback.oneUse,
                isActive: callback.isActive,
                allOrder: callback.allOrder,
                isPublic: callback.isPublic,
              });
            });
          }}
        />
      )}

      {showGroups && (
        <CodeGroup
          setShowGroups={setShowGroups}
          showGroups={showGroups}
          DiscountID={state.id}
          callback={(id) => {
            getDiscountCodeById(id, (callback) => {
              setState({
                id: callback.id,
                discountCode: callback.discountCode,
                expireDate: callback.expireDate
                  ? callback.expireDate.split("T")[0]
                  : "",
                discountCost: callback.discountCost,
                minOrderLimit: callback.minOrderLimit,
                //   smsid: callback.smsid,
                freeDelivery: callback.freeDelivery,
                discountPercent: callback.discountPercent,
                onlyFirstOrder: callback.onlyFirstOrder,
                oneUse: callback.oneUse,
                isActive: callback.isActive,
                allOrder: callback.allOrder,
                isPublic: callback.isPublic,
              });
            });
          }}
        />
      )}
      {showCategoris && (
        <CodeCategory
          setShowCategoris={setShowCategoris}
          showCategoris={showCategoris}
          DiscountID={state.id}
          callback={(id) => {
            getDiscountCodeById(id, (callback) => {
              setState({
                id: callback.id,
                discountCode: callback.discountCode,
                expireDate: callback.expireDate
                  ? callback.expireDate.split("T")[0]
                  : "",
                discountCost: callback.discountCost,
                minOrderLimit: callback.minOrderLimit,
                //   smsid: callback.smsid,
                discountPercent: callback.discountPercent,
                freeDelivery: callback.freeDelivery,
                onlyFirstOrder: callback.onlyFirstOrder,
                oneUse: callback.oneUse,
                isActive: callback.isActive,
                allOrder: callback.allOrder,
                isPublic: callback.isPublic,
              });
            });
          }}
        />
      )}
    </Detail>
  );
}
